import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '../../../apis/baseQuery';
import { ApiResponse } from '../../../model';
import { API_CONSTANTS } from '../../../utils/constants';

import type { SystemSettingsRecord } from './model';

export const systemSettingsApi = createApi({
  reducerPath: 'systemSettingsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['SystemSettings'],
  endpoints: (build) => ({
    getSystemSettings: build.query<ApiResponse<SystemSettingsRecord>, void>({
      query: () => ({
        url: API_CONSTANTS.SYSTEM_SETTINGS.GET_URL,
        method: 'GET',
      }),
      providesTags: [{ type: 'SystemSettings', id: 'GLOBAL' }],
    }),
    updateSystemSettings: build.mutation<
      ApiResponse<SystemSettingsRecord>,
      FormData
    >({
      query: (body) => ({
        url: API_CONSTANTS.SYSTEM_SETTINGS.UPDATE_URL,
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'SystemSettings', id: 'GLOBAL' }],
    }),
  }),
});

export const { useGetSystemSettingsQuery, useUpdateSystemSettingsMutation } =
  systemSettingsApi;

export default systemSettingsApi;
